/**
 * Created by ZengFanhui on 2020/10/26 9:57
 */
module.exports = file => () => import('@/views/' + file + '.vue')
